// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__jDm4c","nav__link":"Nav_nav__link__2y2sA","nav__link_active":"Nav_nav__link_active__2iE70"};